import * as components from './components'
import ToastPlugin from './plugins/toast'
import 'vue-toastification/dist/index.css'
import DialogPlugin from './plugins/dialog'
import { VuetifyLocales } from './plugins/vuetify'
import colors from './scss/presets/colors.module.scss'

const install = (Vue, options = {}) => {
  if (install.installed) return
  install.installed = true

  const context = options.context || {}
  options.components = options.components || components
  // components
  for (const componentName in options.components) {
    const component = components[componentName]

    Vue.component(component.name, Vue.extend(component))
  }

  // Vue.use(ToastPlugin)
  const opts = {
    // You can set your default options here
  }
  Vue.use(ToastPlugin, { context })
  Vue.use(DialogPlugin, { context })
}

const VueEkoolPlugin = {
  install,
}

export default VueEkoolPlugin
export * from './utils'
export * from './mixins'
export * from './components'
export { VuetifyLocales } from './plugins/vuetify'

export const config = {
  theme: {
    options: {
      customProperties: true,
      variations: false,
    },
    themes: {
      light: colors,
      dark: colors,
    },
  },
  breakpoint: {
    mobileBreakpoint: 'xs',
  },
  lang: {
    locales: VuetifyLocales,
  },
}
